import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  flag: {
    top: -20,
    left: -95,
    paddingHorizontal: 8,
    paddingVertical: 2,

    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  wrapper: {
    width: 150,
    flexDirection:'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: PALETTE.primaryActive,
    backgroundColor: PALETTE.primaryBackground,
  },
  flagDate: {
    color: PALETTE.secondaryText,
    textAlign: 'right',
    margin: 4,
  },
  flagPrice: {
    color: PALETTE.secondaryActive,
    lineHeight: 14,
    textAlign: 'right',
  },
  tooltipWrapper: {
    flexDirection:'row',
    width:150,
    //alignSelf:'center',
    justifyContent: 'center',
  },
});
